'use client'

import {FC, forwardRef, Ref, useState} from 'react'
import {cx} from '@local/utils/cx'
import NextImage from 'next/image'
import type {ImageProps} from 'next/image'
import {screens, devices} from '@local/config/dist/theme'

const mobileMockupWidth = devices.mobile.mockupWidth
const desktopMockupWidth = devices.desktop.mockupWidth
const mobileMaxWidth = screens[devices.desktop.screen]

export interface ExtendedImageProps extends ImageProps {
	mobileWidth?: number
	desktopWidth?: number
	mobileOnly?: boolean
	desktopOnly?: boolean
	animated?: boolean
	ref?: Ref<HTMLImageElement> | undefined
}

export const Image: FC<ExtendedImageProps> = forwardRef(({
	src,
	width,
	height,
	mobileWidth = mobileMockupWidth,
	desktopWidth = desktopMockupWidth,
	alt = '',
	fill,
	loader,
	className,
	style,
	mobileOnly = false,
	desktopOnly = false,
	priority = false,
	unoptimized,
	sizes,
	animated = true,
	onLoad,
	...args
}, ref) => {
	const [isLoaded, setIsLoaded] = useState(false)

	const _sizes =
	sizes ||
	`${
		!mobileOnly
			? `(min-width: ${mobileMaxWidth}px) ${Math.round((desktopWidth * 100) / desktopMockupWidth)}vw`
			: `(max-width: ${mobileMaxWidth - 1}px) ${Math.round((mobileWidth * 100) / mobileMockupWidth)}vw`
		}${
		!desktopOnly && !mobileOnly
			? `,${Math.round((mobileWidth * 100) / mobileMockupWidth)}vw`
			: ',0vw'
	}`

	const handleLoad = img => {
		if (onLoad) onLoad(img)
		setIsLoaded(true)
	}

	return (
		<NextImage
			unoptimized={
				unoptimized !== undefined
					? unoptimized
					: process.env.XSTORYBOOK_EXAMPLE_APP !== undefined
			}
			src={src}
			alt={alt}
			fill={fill}
			sizes={_sizes}
			width={fill ? undefined : width}
			height={fill ? undefined : height}
			loader={loader}
			priority={priority}
			style={style}
			className={cx(
				'block',
				mobileOnly && 'lg:hidden',
				desktopOnly && 'lg-max:hidden',
				animated && 'transition-opacity duration-500 ease-out-quart',
				fill && 'object-cover',
				// animated && (isLoaded ? 'opacity-100' : `opacity-0${priority ? ' hover-none:opacity-100' : ''}`),
				animated && (isLoaded ? 'opacity-100' : `opacity-0${priority ? ' opacity-100' : ''}`),
				className,
			)}
			onLoad={handleLoad}
			ref={ref}
			{...args} />
	)
})
